import { render, staticRenderFns } from "./platform-login-form.component.vue?vue&type=template&id=21a1bca2&scoped=true"
import script from "./platform-login-form.component.vue?vue&type=script&lang=ts"
export * from "./platform-login-form.component.vue?vue&type=script&lang=ts"
import style0 from "./platform-login-form.component.vue?vue&type=style&index=0&id=21a1bca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1bca2",
  null
  
)

export default component.exports